import { render } from "./DatasourceSampleData.vue?vue&type=template&id=7630e57e&scoped=true&ts=true"
import script from "./DatasourceSampleData.vue?vue&type=script&lang=ts"
export * from "./DatasourceSampleData.vue?vue&type=script&lang=ts"

import "./DatasourceSampleData.vue?vue&type=style&index=0&id=7630e57e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7630e57e"]])

export default __exports__